import { withTheme } from '@material-ui/core/styles';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const WrapperLog = withTheme(styled.div`
  ${({ theme }) => css`
    width: 90%;
    max-width: 39rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 0.6rem;
    margin: 0 1rem;
    padding: 5rem;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);

    img {
      margin-bottom: 4.8rem;
      max-height: 76px;
    }

    form > div {
      margin-bottom: 3.7rem;
    }

    .versao {
      font-size: 1rem;
    }

    input {
      color: #666;
      font-family: 'Poppins', sans-serif;
    }

    p {
      color: #666;
      margin-top: 2rem;
    }

    a {
      color: ${theme.palette.primary.dark};
      font-weight: 500;
    }

    button {
      height: 5rem;
      border-radius: 2.5rem;
      border: none;
      background-image: linear-gradient(
        to right,
        ${theme.palette.primary.dark},
        ${theme.palette.primary.main},
        ${theme.palette.primary.dark}
      );
      background-size: 200%;
      font-size: 1.5rem;
      transition: 0.5s;
    }

    button:hover {
      background-position: right;
    }

    a.lostpassword-button {
      font: 12px 'Poppins', sans-serif;
      margin-top: 1rem;
      align-self: start;

      font-weight: 500;
      cursor: pointer;

      :hover {
        opacity: 90%;
      }
    }

    @media (max-width: 768px) {
      padding: 2rem 5rem;

      img {
        margin-bottom: 1.5rem;
      }

      form > div {
        margin-bottom: 1rem;
      }

      p {
        margin-top: 1.5rem;
      }

      button {
        margin-top: 2rem;
      }
    }
  `}
`);

export const Logo = withTheme(styled.h2`
  color: ${({ theme }) => theme.palette.error.dark};
  font-family: Arial, Helvetica, sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  font-style: italic;
  user-select: none;
  text-transform: lowercase;
  padding: 0;
  margin-top: 4rem;
  img {
    width: 140px;
    margin-bottom: 0;
  }
`);
